import React, { useState } from 'react';
import { Steps, message } from 'antd';
import { PickerPlatform } from './StepSelectPlatform';
import { FormConsent } from './StepConsent';
import { FormDonationOptions } from './StepDonationOptions'
import { DonationReview } from './StepDonationReview'
import { PageUpload } from './StepUpload'
import { FormSurvey } from './StepSurvey'
import { PageDone } from './StepDone'
import { FetchFromBackend, ErrorConnectionFailed } from './HelperContactBackend';
import './App.css';
import { Alert } from 'antd';

const Step = Steps.Step;

export const PageDataDonation = () => {

  const [platform, setPlatform] = useState(null);
  const [currentStep, setCurrentStep] = useState(0);
  const [sessionId, setSessionId] = useState(null);
  const [emailIdentifier, setEmailIdentifier] = useState("");
  const [amountToBePayed, setAmountToBePayed] = useState(0);
  const [donationOptions, setDonationOptions] = useState(null);
  const [donationOptionsSet, setDonationOptionsSet] = useState(false);
  const [userData, setUserData] = useState(null);
  const [demographicSurveyQuestions, setDemographicSurveyQuestions] = useState(null);
  const [usageSurveyQuestions, setUsageSurveyQuestions] = useState(null);
  const [techsavvinessSurveyQuestions, setTechsavvinessSurveyQuestions] = useState(null);

  const payingParticipants = true;

  const [dimensions, setDimensions] = useState({
    height: window.innerHeight,
    width: window.innerWidth
  });

  const [useMobileVersion, setUseMobileVersion] = useState(window.innerWidth <= 768);
  React.useEffect(() => {
    function handleResize() {
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth
      })
      setUseMobileVersion(window.innerWidth <= 768);
    }

    window.addEventListener('resize', handleResize)

    return _ => {
      window.removeEventListener('resize', handleResize)

    }
  })

  function moveToEnd(){
    setCurrentStep(currentStep+2);
    window.scrollTo(0, 0);
  }
  
  function next() {
    //console.log("payingParticipants", payingParticipants);
    setCurrentStep(currentStep + 1);
    window.scrollTo(0, 0);
  }
  function prev() {
    setCurrentStep(currentStep - 1);
    window.scrollTo(0, 0);
  }
  
  // For stepper
  const steps = [{
    title: 'Select Platform',
    content: (<PickerPlatform
      next={next}
      payingParticipants={payingParticipants}
      setPlatform={setPlatform}
      setSessionId={setSessionId}
      setEmailIdentifier={setEmailIdentifier}
      useMobileVersion={useMobileVersion} />)
  }, {
    title: 'Consent Form',
    content: (<FormConsent
      next={next}
      prev={prev}
      platform={platform}
      setPlatform={setPlatform}
      sessionId={sessionId} />)
  }, {
    title: 'Donation Options/Information',
    content: (<FormDonationOptions
      next={next}
      prev={prev}
      platform={platform}
      donationOptions={donationOptions}
      payingParticipants={payingParticipants}
      setDonationOptions={setDonationOptions}
      donationOptionsSet={donationOptionsSet}
      setDonationOptionsSet={setDonationOptionsSet}
      useMobileVersion={useMobileVersion} />)
  }, {
    title: 'Donation Review',
    content: (<DonationReview
      next={next}
      prev={prev}
      platform={platform}
      donationOptions={donationOptions} />)
  }, {
    title: 'File Upload',
    content: (<PageUpload
      next={next}
      prev={prev}
      moveToEnd={moveToEnd}
      payingParticipants={payingParticipants}
      donationOptions={donationOptions}
      sessionId={sessionId}
      platform={platform}
      emailIdentifier={emailIdentifier}
      amountToBePayed={amountToBePayed}
      setAmountToBePayed={setAmountToBePayed}
      userData={userData}
      setUserData={setUserData}
      setDemographicSurveyQuestions={setDemographicSurveyQuestions}
      setTechsavvinessSurveyQuestions={setTechsavvinessSurveyQuestions}
      setUsageSurveyQuestions={setUsageSurveyQuestions} />)
  }, {
    title: 'Survey',
    content: (<FormSurvey
      next={next}
      useMobileVersion={useMobileVersion}
      platform={platform}
      sessionId={sessionId}
      emailIdentifier={emailIdentifier}
      donationOptions={donationOptions}
      demographicSurveyQuestions={demographicSurveyQuestions}
      usageSurveyQuestions={usageSurveyQuestions}
      techsavvinessSurveyQuestions={techsavvinessSurveyQuestions}
      setAmountToBePayed={setAmountToBePayed} />)
  }, {
    title: 'Done',
    content: (<PageDone
      payingParticipants={payingParticipants}
      emailIdentifier={emailIdentifier}
      amountToBePayed={amountToBePayed}/>)
  }];

  return (<><Steps
    current={currentStep}
    direction={(window.innerWidth > 768) ? "horizontal" : "vertical"}
    labelPlacement='vertical'
  >
    {steps.map(item => <Step key={item.title} title={item.title} />)}
  </Steps>
    <div>
      {steps[currentStep].content}
    </div>
    </>)
}